import { render, staticRenderFns } from "./BusyIndicator.vue?vue&type=template&id=88c968e0&"
import script from "./BusyIndicator.vue?vue&type=script&lang=js&"
export * from "./BusyIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports